import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Table, Form } from "react-bootstrap";
import { useNavigate, Link, useLocation } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import Main from "../layout/Main";
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import Badge from "react-bootstrap/Badge";
import { formatDateForView } from "../../utils/helper";
import { BrowserView } from "react-device-detect";
import InfoPill from "../InfoPill";
import { ROUTES } from "../../constants/webRouting";


const CategoryList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchText, setSearchText] = useState("");

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = rows.filter((row) =>
      Object.values(row).some(
        (field) =>
          field && field.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilteredRows(filtered);
  };

  async function init() {
    const result = await solisPowerApi.getCategoryList();
    if (result) {
      const mappedRows = result.map((item, index) => ({
        id: item.id || index,
        category_name: item.category_name || "-",
        status: item.status || "-",
        createddate: item.createddate || "-",
      }));
      setRows(mappedRows);
      setFilteredRows(mappedRows);
    }
  }

  useEffect(() => {
    init();
  }, []);

  const columns = [
    {
      field: "category_name",
      headerName: "Category Name",
      flex: 1,
      renderCell: (params) => (
        <Link
          to={ROUTES.CATEGORY.CREATE}
          state={params.row}
          style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}
        >
          {params.row.category_name}
        </Link>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Badge bg={params.row.status === "Active" ? "success" : "secondary"}>
          {params.row.status}
        </Badge>
      ),
    },
    {
      field: "createddate",
      headerName: "Created Date",
      flex: 1,
      renderCell: (params) =>
        params.row?.createddate ? formatDateForView(params.row.createddate) : "",
    },
  ];

  return (
    <Main>
      <Container>
        <Row>
          <Col lg={12}>
            <Row className="align-items-end my-2">
              <Col lg={2} md={4} sm={12}>
                <div className="leads-header">
                  <div className="leads-actions">
                    <TextField
                      size="small"
                      placeholder="Search Category..."
                      className="custom-search-field"
                      value={searchText}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>
                </div>
              </Col>

              <Col lg={2} md={4} sm={12} className="py-1">
                <BrowserView>
                  <div className="d-flex py-1 px-2 ">
                    <InfoPill
                      left="Total"
                      right={rows.length}
                      rightClasses="bg-custom text-white border-white fw-bold"
                      leftClasses="bg-white fw-bold"
                    />
                  </div>
                </BrowserView>
              </Col>

              <Col className="d-flex flex-col justify-content-end align-items-end">
                <Button size="sm" className="btn-create" onClick={() => navigate(ROUTES.CATEGORY.CREATE)}>
                  New Category
                </Button>
              </Col>
            </Row>

            <Row>
              <div className="leads-page">
                <div style={{ height: 400, width: "100%", marginTop: "20px", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}>
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    pageSize={25}
                    rowsPerPageOptions={[25]}
                    getRowHeight={() => "auto"}
                    disableRowSelectionOnClick
                    className="custom-datagrid"
                  />
                </div>
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
    </Main>
  );
};

export default CategoryList;
